// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import EmptyImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/empty/components/generic-empty-state';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import DeprecationMessage from '../deprecation-message';
import messages from './messages';

export type Props = {
	onAdd: () => void;
	intl: IntlShape;
};

const MAX_EMPTY_IMAGE_SIZE = 250;
const CAC_JSD_AUTOMATION_URL =
	'https://confluence.atlassian.com/servicedeskcloud/automating-your-service-desk-732528900.html';

// eslint-disable-next-line jira/react/no-class-components
class EmptyView extends PureComponent<Props> {
	onLearnMoreClicked = () => {
		triggerAnalyticsEvent('summary.empty-view.learn-more');
	};

	render() {
		// FREE-2099 - add call to add rule action.
		const {
			intl: { formatMessage },
			onAdd,
		} = this.props;

		return (
			<>
				<DeprecationMessage />
				<EmptyState
					header=""
					size="wide"
					maxImageWidth={MAX_EMPTY_IMAGE_SIZE}
					maxImageHeight={MAX_EMPTY_IMAGE_SIZE}
					renderImage={getAkEmptyStateRenderImageFn(EmptyImage)}
					isLoading={false}
					description={formatMessage(messages.description)}
					primaryAction={
						<Button appearance="primary" isDisabled={false} onClick={onAdd}>
							{formatMessage(messages.addRule)}
						</Button>
					}
					tertiaryAction={
						<a
							href={CAC_JSD_AUTOMATION_URL}
							target="_blank"
							rel="noopener noreferrer"
							onClick={this.onLearnMoreClicked}
						>
							{formatMessage(messages.learnMore)}
						</a>
					}
				/>
			</>
		);
	}
}

export default injectIntl(EmptyView);
